import React from "react";
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import InfoCard from "../InfoCard";


const Container = styled.div`
    width: 100%;
    background-color: ${({theme}) => theme?.colors?.greyLighter || "#F8F8F8"};
    padding: 12px;
    margin-block: 36px;
    margin-top: 0px;
    padding-top: 0px;
    box-sizing: border-box;
    @media (max-width: 600px){    
        width: 100vw;
        overflow-x: hidden;
        padding: 5%;
        box-sizing: border-box;
        margin-left: -5%;
    }
`;

const CardsContainer = styled.div`
    width: 100%;
    display: ${({isMasonStyle=false}) => isMasonStyle ? "grid" : "flex"};
    gap: 8px;
    box-sizing: border-box;
    margin-top: 12px;
    @media (max-width: 600px){
        display: flex;   
        flex-direction: column;
        padding: none;
    }
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 2fr;
    div:first-child{
        grid-area: 1/1/3/1;
    }
    div:nth-child(2){
        grid-area: 1/2/3/2;
    }
    div:nth-child(3){
        grid-area: 1/3/1/3;
    }
    div:nth-child(4){
        grid-area: 2/3/2/3;
    }
    
`;


const InfoCardsSection = ({title="", subTitle="", isMasonStyle = false, data=[], children=[]}) => {
    return(
        <Container>
            <Title type="h2">{title}</Title>
            <Text>{subTitle}</Text>
            <CardsContainer isMasonStyle={isMasonStyle}>
                {data.map((cardData, idx) => <InfoCard key={`info_card_${idx}`} {...cardData} />)}
                {children}
            </CardsContainer>
        </Container>
    )
}

export default InfoCardsSection;